import React from 'react';
import { Button } from 'antd';

/**
 * Google login button — always visible to all users.
 * Clicking redirects the browser to the backend Google OAuth initiate endpoint,
 * which redirects to Google's consent screen.
 */
const GoogleLoginButton: React.FC = () => {
  const handleLogin = () => {
    localStorage.removeItem('@token');
    localStorage.removeItem('@refreshToken');
    localStorage.removeItem('persist:root');
    // Pass the current portal origin so the backend redirects back here, not app.zoomlogi.com
    const returnTo = encodeURIComponent(window.location.origin);
    const initiateUrl = `${process.env.REACT_APP_BASE_URL}auth/google/initiate/?return_to=${returnTo}`;
    window.location.href = initiateUrl;
  };

  return (
    <>
      <Button
        onClick={handleLogin}
        data-testid='google-login-button'
        style={{
          width: '100%',
          height: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          border: '1px solid #d9d9d9',
          borderRadius: '8px',
          backgroundColor: 'var(--surface-container)',
          color: 'var(--text-primary)',
          fontWeight: 500,
          fontSize: '14px',
        }}
        block
      >
        Sign in with Google
      </Button>
    </>
  );
};

export default GoogleLoginButton;
